import React, { useEffect, useState } from "react";
import TestDefault from "./default/TestDefault";
import TestIIT from "./iit/TestIIT";
import { useLanguages } from "../../context/LanguagesContext";
import { useQuestion } from "../../context/QuestionsContext";
import { useProfile } from "../../context/ProfileContext";
import { useNavigate } from "react-router-dom";
import ROUTES_NAME from "../../constants/RoutesName";
import GateTest from "./gate/GateTest";
import internetIssue from "../../images/internetissue.jpeg";
import { decryptData } from "../../crypto";
import { useMediaQuery } from "@mui/material";
import Loader from "../../components/Loader";
import FeedbackTest from "./feedback/FeedbackTest";
import IpMat from '../test/ipmat/GateTest'


function Test({}) {
  const { fetchProfileData } = useProfile();
  const { fetchQuestions } = useQuestion();
  const { fetchLanguagesData } = useLanguages();
  const [isOffline, setIsOffline] = useState(false);
  const isDesktop = useMediaQuery("(min-width:768px)");
  const isMobile = useMediaQuery("(max-width:599px)");
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:768px)");

  const navigate = useNavigate();

  useEffect(() => {
    fetchProfileData();
  }, []);

  useEffect(() => {
    const examId = sessionStorage.getItem("examId");
    if (examId) {
      fetchQuestions(examId);
      fetchLanguagesData(examId);
    }
  }, []);

  useEffect(() => {
    const examToken = sessionStorage.getItem("examToken");
    const userName = sessionStorage.getItem("userName");
    const examStarted = sessionStorage.getItem("examStarted");

    if (examToken && userName && examStarted) {
      navigate(ROUTES_NAME.TEST);
    }
  }, []);

  useEffect(() => {
    function handleOffline() {
      setIsOffline(true);
    }
    function handleOnline() {
      setIsOffline(false);
    }
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  const componentMap = {
    // iit: <TestIIT />,
    iit: <TestIIT />,
    "ssc/railway": <GateTest />,
    ipmat: <IpMat />,
    // default: <TestDefault />,
    default: <FeedbackTest />,
  };

  const getComponentType = () => {
    // if (isMobile || isTablet) {
    //   return "default";
    // } else {
    //   return decryptData(sessionStorage.getItem("exam_template")) || "";
    // }
    return decryptData(sessionStorage.getItem("exam_template")) || "";
  };

  const type = getComponentType();

  return isOffline ? (
    <div style={{ textAlign: "center", marginTop: "2%" }}>
      <img src={internetIssue} alt="Internet Issue" />
    </div>
  ) : (
    componentMap[type] || <Loader />
  );
}

export default Test;
